import { styled, Theme } from "@mui/material";
import Slider from "@mui/material/Slider";

interface StyledSliderProps {
  isSimpleSlider?: boolean;
  size: "small" | "medium";
}

type SliderSizeProps = {
  theme: Theme;
  size: "small" | "medium";
  orientation?: "horizontal" | "vertical";
};

const getSliderThumbSize = (theme: Theme, size: "small" | "medium") => `calc(
    ${theme.wsc.size.m} * ${size === "medium" ? 1.25 : 1}
  )`;

const getSliderHeight = ({ theme, size, orientation }: SliderSizeProps) =>
  orientation === "vertical"
    ? "100%"
    : theme.wsc.size[size === "medium" ? "s" : "xs"];

const getSliderWidth = ({ theme, size, orientation }: SliderSizeProps) =>
  orientation === "vertical"
    ? theme.wsc.size[size === "medium" ? "s" : "xs"]
    : "100%";

const StyledSlider = styled(Slider, {
  shouldForwardProp: (prop) => prop !== "isSimpleSlider",
})<StyledSliderProps>`
  color: ${({ theme }) => theme.wsc.palette.primary[300]};

  .MuiSlider-rail {
    color: ${({ theme }) => theme.wsc.palette.neutral[500]};
    opacity: 1;
    height: ${(props) => getSliderHeight(props)};
    width: ${(props) => getSliderWidth(props)};
  }

  .MuiSlider-track {
    color: ${({ theme }) => theme.wsc.palette.neutral[0]};
    border: 0;
    height: ${(props) => getSliderHeight(props)};
    width: ${(props) => getSliderWidth(props)};
  }

  .MuiSlider-thumb {
    width: ${({ theme, size }) => getSliderThumbSize(theme, size)};
    height: ${({ theme, size }) => getSliderThumbSize(theme, size)};

    ${(props) =>
      props.isSimpleSlider
        ? `
                box-shadow: inherit;
                width: 0;
                height: 0;
            `
        : `
                color: ${props.theme.wsc.palette.neutral[0]};
            `}

    &:focus, &:hover, &.Mui-active, &.Mui-focusVisible {
      box-shadow: inherit;
    }
  }

  .MuiSlider-valueLabel {
    top: -${({ isSimpleSlider }) => (isSimpleSlider ? 0.5 : 0.75)}rem;
    background-color: ${(props) =>
      props.isSimpleSlider
        ? `transparent`
        : `${props.theme.wsc.palette.neutral[0]}`};
    color: ${(props) =>
      props.theme.wsc.palette.neutral[props.isSimpleSlider ? 100 : 600]};
    border-radius: ${(props) => props.theme.wsc.radius.m};
    ${(props) => props.theme.wsc.typography.body1bold};
  }
`;
export default StyledSlider;
